import { Component, OnInit, ChangeDetectorRef, Injector } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PortalInfoService } from 'src/app/Services/portal-info/portal-info.service';
import { Title } from '@angular/platform-browser';
import { Home1Component } from '../home1/home1.component';
import { KeycloakProfile } from 'keycloak-js';
import { Urls } from 'src/app/Models/Urls';
import { CookieService } from 'ngx-cookie-service';
import { MenuItem } from 'primeng/api/menuitem';
import { AuthService } from 'src/app/Services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { Variables } from 'src/app/Models/variables';
import * as CryptoJS from 'crypto-js';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageComponent implements OnInit {

  title: string;
  fullName: string;

  instances = [];

  userDetails: KeycloakProfile;
  isManage: boolean;
  http: any;

  urls = new Urls();
  organisation: any;

  items: MenuItem[];
  isAccount = false;
  isLanguage: boolean;

  portalHeaderColor = 'transparent';

  icon: any;

  constructor(
    // private keycloakService: KeycloakService,
    private router: Router,
    public translate: TranslateService,
    private portalinfo: PortalInfoService,
    private titleService: Title,
    private home: Home1Component,
    private cookieService: CookieService,
    private injector: Injector,
    private auth: AuthService,
    private app: AppComponent
    ) {
      router.navigateByUrl('/manageapps');
      if (localStorage.getItem('portal-title') === null) {
        portalinfo.getPortalInfo().subscribe((res) => {
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < res.length; i++) {
            this.title = res[i].portalTitle;
            localStorage.setItem('portal-title', res[i].portalTitle);
            localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
            this.portalHeaderColor = res[i].portalHeaderColor;
            localStorage.setItem('headercolor', res[i].portalHeaderColor);

            this.titleService.setTitle(res[i].portalTitle);
          }
        });
      } else {
        this.title = localStorage.getItem('portal-title');
        this.titleService.setTitle(this.title);

        this.portalHeaderColor = localStorage.getItem('headercolor');
      }

      this.icon = app.icon;

      // translate.addLangs(['English', 'French']);
      // translate.setDefaultLang('English');

      // let browserLang = translate.getBrowserLang();
      // if (localStorage.getItem('language') !== null) {
      //   browserLang = localStorage.getItem('language');
      // }
      // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

      translate.use('English');

      this.translate.get('MANAGE.APPS').subscribe((resp1: string) => {
        this.translate.get('MANAGE.INSTANCES').subscribe((resp2: string) => {
          this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3: string) => {
            this.translate.get('GENERAL.ICONS').subscribe((resp4: string) => {
              this.items = [];
              this.items.push({ label: resp1, routerLink: ['/manageapps'] });
              this.items.push({ label: resp2, routerLink: ['/manageinstances'] });

              const v = new Variables();
              const va = localStorage.getItem('eu');
              const eu = CryptoJS.AES.decrypt(va, v.pass).toString(CryptoJS.enc.Utf8);
              const usr = JSON.parse(eu);

              const og = usr.organisationName;
              if (og === 'ORG_SUPER_ADMIN') {
                this.isLanguage = true;
                this.isManage = true;
                this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
              }
              this.items.push({ label: resp4, routerLink: ['/icons'] });
            });
          });
        });
      });

      this.loadUserProfile();
    }

  ngOnInit() {
  }

  gotoAccount() {
    const variables = new Variables();
    window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
  }

  gotoLanguage() {
    this.router.navigateByUrl('/language');
  }

  changePass() {
    this.router.navigateByUrl('/change-password');
  }

  changePin() {
    this.router.navigateByUrl('/change-pin');
  }

  logout() {
    localStorage.clear();

    this.cookieService.delete('goepla-portal-organisation-id');
    this.cookieService.delete('goepla-portal-user-id');
    this.cookieService.delete('goepla-portal-language');

    if (environment.useKeycloak === 'true') {
      const keycloakService = this.injector.get(KeycloakService);
      keycloakService.logout(this.urls.appUrl + '/');
    } else {
      this.auth.logout();
      // window.location.reload();
    }
  }

  async loadUserProfile() {
    if (environment.useKeycloak === 'true') {
      const keycloakService = this.injector.get(KeycloakService);
      keycloakService.loadUserProfile().then((user) => {
        this.fullName = user.firstName + ' ' + user.lastName;
        if (localStorage.getItem('fullname') != null) {
          this.fullName = localStorage.getItem('fullname');
        }

        const v = new Variables();
        const va = localStorage.getItem('eu');
        const eu = CryptoJS.AES.decrypt(va, v.pass).toString(CryptoJS.enc.Utf8);
        const usr = JSON.parse(eu);

        if (va !== null) {
          const extUser = usr;
          this.organisation = extUser.organisationName;
        }
      });
    } else {
      const v = new Variables();
      const va = localStorage.getItem('eu');
      const eu = CryptoJS.AES.decrypt(va, v.pass).toString(CryptoJS.enc.Utf8);
      const user = JSON.parse(eu);

      this.organisation = user.organisationName;
      this.fullName = user.firstName + ' ' + user.lastName;
    }
  }

  gotoManage() {
    this.router.navigateByUrl('/manage');
  }

}
